"use strict";

require("bower_components/angular/angular.js");
require("bower_components/bootstrap-sass/assets/javascripts/bootstrap.min.js");

// module
require("bower_components/angular-bootstrap/ui-bootstrap-tpls.js");
require("bower_components/angular-ui-router/release/angular-ui-router.min.js");
require("bower_components/angular-css/angular-css.min.js");
require("bower_components/angular-modal-service/dst/angular-modal-service.js");
require("bower_components/angular-tree-control/angular-tree-control.js");
require("bower_components/angular-gettext/dist/angular-gettext.min.js");
require("bower_components/angular-resource/angular-resource.js");
require("bower_components/angular-touch/angular-touch.js");
require("bower_components/ngCordova/dist/ng-cordova.min.js");
require("bower_components/angular-cookies/angular-cookies.min.js");
require("node_modules/angular-flash-alert/dist/angular-flash.min.js");
require("bower_components/ngInfiniteScroll/build/ng-infinite-scroll.min.js");
require("bower_components/angular-loading-bar/build/loading-bar.min.js");
require("bower_components/angular-animate/angular-animate.js");
require("bower_components/angular-sanitize/angular-sanitize.js");
require("bower_components/slick-carousel/slick/slick.js");
require("bower_components/eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min.js");
require("node_modules/angular-eonasdan-datetimepicker/dist/angular-eonasdan-datetimepicker.js");
require("bower_components/wip-image-zoom/dist/wip-image-zoom.js");
require("bower_components/angular-libphonenumber/dist/libphonenumber.js");
require("bower_components/angular-libphonenumber/dist/angular-libphonenumber.min.js");
require("bower_components/pdfjs-dist/build/pdf.js");
require("bower_components/angular-pdf/dist/angular-pdf.js");
require("node_modules/checklist-model/checklist-model.js");

require("core/precise-currency/precise-currency.module.js");
require("core/password-strength-validator/password-strength-validator.module.js");
require("core/autofocus/autofocus.module.js");
require("core/prevent-unsaved-changes/prevent-unsaved-changes.module.js");

// CSS
require("libs/font-awesome/scss/fontawesome.scss");
require("libs/font-awesome/scss/regular.scss");
require("libs/font-awesome/scss/solid.scss");
require("bower_components/angular-loading-bar/build/loading-bar.min.css");
require("bower_components/animate.css/animate.min.css");
require("bower_components/slick-carousel/slick/slick.css");
require("bower_components/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css");
require("bower_components/wip-image-zoom/dist/wip-image-zoom.css");

angular.module("core", [
    "ui.bootstrap",
    "ui.router",
    "angularCSS",
    "angularModalService",
    "treeControl",
    "gettext",
    "ngResource",
    "ngTouch",
    "ngCordova",
    "ngCookies",
    "ngFlash",
    "infinite-scroll",
    "angular-loading-bar",
    "ngAnimate",
    "ngSanitize",
    "ae-datetimepicker",
    "cwill747.phonenumber",
    "preciseCurrency",
    "passwordStrengthValidator",
    "autofocus",
    "wipImageZoom",
    "tandibar/ng-rollbar",
    "pdf",
    "checklist-model",
]);

require("core/API.js");
require("core/Filters.js");
require("core/is-empty/is-empty.filter.js");
require("core/ng-rollbar/ng-rollbar.js");

// Constants
require("core/moment/moment.constant.js");
require("core/rollbar/rollbar.constant.js");
require("core/image-blob-reduce/image-blob-reduce.constant.js");
require("core/semver/semver.constant.js")
require("core/bowser/bowser.constant.js");
require("core/tags-input/tags-input.constant.js");
require("core/import-logs/import-log-type.constant.js");
require("core/common/common.constant.js");
require("core/form-error/form-error.constant.js");
require("core/support-assistant/support-assistant.constant.js");
require("core/mobile-app/mobile-app.constant.js");
require("core/company/company.constants.js");
require("core/user-verification/user-verification.constant.js");
require("core/shipping-rate/shipping-rate.constant.js");
require("core/order/order.constants.js");
require("core/customer-model/customer.constants.js");
require("core/invoice-attachment/invoice-attachment.constants.js");
require("core/partnership-model/partnership.constant.js");
require("core/payment-methods/payment-methods.constants.js");
require("core/payment/payment.constants.js");
require("core/product/product.constants.js");

// Controllers
require("core/terms-of-service/terms-of-service.controller.js");
require("core/reset-password/reset-password.controller.js");
require("core/reset-password/forgot-username.controller.js");
require("core/reset-password/request-code.controller.js");
require("core/profile/profile.controller.js");
require("core/support-assistant/support-assistant.interceptor.js");
require("core/format-number/abstract-format-number.controller.js");
require("core/http-error-response/not-found.controller.js");
require("core/http-error-response/maintenance.controller.js");

// Templates
require("core/payment-methods/modals/pre-authorized-payment.html");
require("core/pdf/viewer.html");

// Services / Factories
require("core/common/common.service.js");
require("core/language/language.service.js");
require("core/brand-site/brand-site.service.js");
require("core/profile/profile.service.js");
require("core/invoice-print-button/invoice-print-button.service.js");
require("core/order-print-button/order-print-button.service.js");
require("core/payment-print-button/payment-print-button.service.js");
require("core/deposit-slip-print-button/deposit-slip-print-button.service.js");
require("core/unpaid-invoices-statement-print-button/unpaid-invoices-statement-print-button.service.js");
require("core/unpaid-invoices-statement-print-button/sales-rep-unpaid-invoices-statement-print-button.service.js");
require("core/user/user.service.js");
require("core/user/user-type.service.js");
require("core/loader-google-map-api/loader-google-map-api.service.js");
require("core/industry/industry.service.js");
require("core/group/group.service.js");
require("core/product-categories/product-categories.service.js");
require("core/support-assistant/request-support.service.js");
require("core/state-extension/state-extension.service.js");
require("core/user-verification/user-verification.service.js");
require("core/department-selector/department.service.js");
require("core/invoice/invoice.service.js");
require("core/invoice/invoice-status.service.js");
require("core/order/core-order.service.js");
require("core/order/order-status.service.js");
require("core/invoice-attachment/invoice-attachment.service.js");
require("core/zebra-printer/zebra-printer.service.js");
require("core/validate-browser-cookie-support/validate-browser-cookie-support.service.js");
require("core/convert-to-parameter/convert-to-parameter.service.js");
require("core/payment/payment.service.js");
require("core/payment-methods/payment-methods.service.js");
require("core/payment-methods/payment-methods-bank.service.js");
require("core/payment-methods/payment-methods-credit-card.service.js");
require("core/payment-status-filter/payment-status-filter.service.js");
require("core/invoice-status-filter/invoice-status-filter.service.js");
require("core/readonly-permission/readonly-permission.service.js");
require("core/email-input-modal/email-input-modal.service.js");
require("core/product-variants/core-product-variant.service.js");
require("core/minimum-version/minimum-version-interceptor.factory.js");
require("core/start-end-date/abstract-start-end-date-time.controller.js");
require("core/css-useable-activator/css-useable-activator.factory.js");
require("core/workflow/workflow.factory.js");
require("core/promotion/discount-calculator.factory.js");
require("core/promotion/rebate-calculator.factory.js");
require("core/toggle-nav/toggle-nav.factory.js");
require("core/pattern/pattern.factory.js");
require("core/flash-bag/flash-bag.factory.js");
require("core/form-error/form-error.factory.js");
require("core/action/action.factory.js");

// Directives
require("core/wg-click/wg-click.directive.js");
require("core/std-address/std-address.directive.js");
require("core/positive-number/positive-number.directive.js");
require("core/only-numbers-and-decimal-point-input/only-numbers-and-decimal-point-input.directive.js");
require("core/compare-to/compare-to.directive.js");
require("core/ignore-dirty/ignore-dirty.directive.js");
require("core/zoomable-image/zoomable-image.directive.js");
require("core/address/address.directive.js");
require("core/locale-selector/locale-selector.directive.js");
require("core/locale-dropdown-menu/locale-dropdown-menu.directive.js");
require("core/fileread/fileread.directive.js");
require("core/contact-support/contact-support.directive.js");
require("core/user-verification/user-verification.directive.js");
require("core/file-model/file-model.directive.js");
require("core/wg-btn-checkbox/wg-btn-checkbox.directive.js");
require("core/invoice-item/invoice-item.directive.js");
require("core/order-item/order-item.directive.js");
require("core/invoice-attachment/invoice-image-attachment-add.directive.js");
require("core/confirm-password/confirm-password.directive.js");
require("core/element-ready/element-ready.directive.js");

// Components
require("core/listing-filter/listing-filter.component.js");
require("core/invoice/invoice-details.component.js");
require("core/order/order-details.component.js");
require("core/invoice-print-button/invoice-print-button.component.js");
require("core/order-print-button/order-print-button.component.js");
require("core/payment-print-button/payment-print-button.component.js");
require("core/deposit-slip-print-button/deposit-slip-print-button.component.js");
require("core/unpaid-invoices-statement-print-button/unpaid-invoices-statement-print-button.component.js");
require("core/start-end-date/start-end-date-time.component.js");
require("core/start-end-date/start-end-date-time-filter.component.js");
require("core/login/login-form.component.js");
require("core/login/login-form.component.js");
require("core/barcode/barcode.component.js");
require("core/versions/versions.component.js");
require("core/pagination/pagination.component.js");
require("core/mptt-selector/mptt-selector.component.js");
require("core/mptt-viewer/mptt-viewer.component.js");
require("core/terms-of-service/terms-of-service-agreement/terms-of-service.component.js");
require("core/terms-of-service/terms-of-service-content/terms-of-service-content.component.js")
require("core/btn-ordered/btn-ordered.component.js");
require("core/timezone/timezone.component.js");
require("core/help-tip/help-tip.component");
require("core/help-tip-html/help-tip-html.component");
require("core/image-upload/image-upload.component.js");
require("core/file-upload/file-upload.component.js");
require("core/footer/main-footer.component.js");
require("core/btn-delete/btn-delete.component.js");
require("core/support-assistant/support-assistant.component.js");
require("core/search/search.component.js");
require("core/btn-add/btn-add.component.js");
require("core/action/bulk-action.component.js");
require("core/action/single-action.component.js");
require("core/selection-count/selection-count.component.js");
require("core/sort-by/sort-by.component.js");
require("core/date-filter/date-filter.component.js");
require("core/status-date-filter/status-date-filter.component.js");
require("core/payment-due-date-filter/payment-due-date-filter.component.js");
require("core/status-filter/status-filter.component.js");
require("core/order-contact-type-filter/order-contact-type-filter.component.js");
require("core/inventory-quantity-filter/inventory-quantity-filter.component.js");
require("core/tag-filter/tag-filter.component.js");
require("core/checkbox-all/checkbox-all.component.js");
require("core/status-inline/status-inline.component.js");
require("core/tag-inline/tag-inline.component.js");
require("core/invoice-payment-inline/invoice-payment-inline.component.js");
require("core/btn-save/btn-save.component.js");
require("core/form-import/form-import.component.js");
require("core/department-selector/department-selector.component.js");
require("core/order-revisions/order-revisions.component.js");
require("core/order-revisions/order-revisions-warning.component.js");
require("core/image-carousel/image-carousel.component.js");
require("core/invoice-attachment/invoice-attachment.component.js");
require("core/invoice-attachment/invoice-attachment-button.component.js");
require("core/invoice-attachment/invoice-attachment-link.component.js");
require("core/payment-methods/payment-method-bank.component.js");
require("core/payment-methods/payment-method-credit-card.component.js");
require("core/payment-methods/credit-card-icon.component.js");
require("core/payment-method-filter/payment-method-filter.component.js");
require("core/payment/payment-details.component.js");
require("core/format-number/format-payment-number/format-payment-number.component.js");
require("core/format-number/format-invoice-number/format-invoice-number.component.js");
require("core/format-number/format-order-number/format-order-number.component.js");
require("core/pre-authorized-payment-agreement-button/pre-authorized-payment-agreement-button.component.js");
require("core/pre-authorized-payment-agreement-button/pre-authorized-payment-agreement-button.service.js");

// Modals
require("core/action/confirmation.modal.js");
require("core/contact-support/modals/contact-support.modal.js");
require("core/user-verification/modals/user-verification.modal.js");
require("core/email-input-modal/email-input-modal.modal.js");
require("core/readonly-permission/modal/readonly-permission.modal.js");
require("core/listing-filter/modal/listing-filter.modal.js");
require("core/zoomable-image/zoomable-image.modal.js");
require("core/confirmation/confirmation.modal.js");
require("core/support-assistant/support-assistant.modal.js");
require("core/zebra-printer/zebra-printer-select.modal.js");
require("core/payment-methods/modals/payment-methods-bank-account.modal.js");
require("core/payment-methods/modals/payment-methods-credit-card-account.modal.js");
require("core/confirm-password/confirm-password.modal.js");
require("core/pre-authorized-payment-agreement-button/modal/pre-authorizer-payment-agreement.modal.js");

// Deprecated
require("core/deprecated/BackButton.js");



//////////////////
// WEBPACK FOOTER
// ./core/core.module.js
// module id = 5
// module chunks = 0